module.exports = __webpack_public_path__ + "static/media/politica-confidentialitate-POLONIQ.6d051f04.pdf";